// extracted by mini-css-extract-plugin
module.exports = {"content":"_3Fpggl7YDl1pXfWKytjM8w"};